// extracted by css-extract-rspack-plugin
export default {"caption":"caption-SeWvqT"};